import api from '@pray/shared/utils/api';

import type { CreateLeadSegmentResponse } from './data/response';
import type { LeadSegmentConditionGroup } from './transformers/types';

export type CreateLeadSegmentParams = {
  artistId: string;
  name: string;
  description: string;
  conditions: LeadSegmentConditionGroup;
};

export async function createLeadSegment({ artistId, name, description, conditions }: CreateLeadSegmentParams) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!name) throw new Error('Segment name is required');
  if (!conditions) throw new Error('Segment conditions are required');

  const data = {
    name,
    description,
    conditions,
  };

  const url = `/web/studio/artists/${artistId}/lead-segments`;
  const response = await api.executePostRequest<CreateLeadSegmentResponse>(url, data);

  return response.data;
}
